"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var AnimationObjectsMap_1 = require("../helpers/AnimationObjectsMap");
var AssetFactory_1 = require("./AssetFactory");
var AssetsMap = (function (_super) {
    tslib_1.__extends(AssetsMap, _super);
    function AssetsMap() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AssetsMap.prototype.importElement = function (rawData, version) {
        return AssetFactory_1.AssetFactory.constructAssetFromRawData(rawData, version);
    };
    AssetsMap.prototype.getElementKey = function (element) {
        return element.id;
    };
    return AssetsMap;
}(AnimationObjectsMap_1.AnimationObjectsMap));
exports.AssetsMap = AssetsMap;
//# sourceMappingURL=AssetsMap.js.map